import {
  axiosInstancePromotion,
  CustomResponseFormat,
} from "./instancePromotion";

// OAuth 풀페이지 리다이렉트를 견디도록 레퍼럴 코드를 localStorage 에 보관한다.
// 진입(/with/:code) 시 저장하고, 로그인 완료 시점에 소비(전송 후 제거)한다.
export const AFFILIATE_REFERRAL_CODE_STORAGE_KEY = "AFFILIATE_REFERRAL_CODE";

export const AFFILIATE_DOMAIN = "affiliate";

export const AFFILIATE_REFERRAL_SAVE_ENDPOINT = "referral/save";
export const AFFILIATE_REFERRAL_VALIDATE_ENDPOINT = "referral/validate";

// 게이트 검증 응답: valid=유효 여부, name=화면 노출용 제휴사 이름(코드 아님).
export type AffiliateReferralInfo = {
  valid: boolean;
  name?: string | null;
};

export const affiliateApi = {
  saveReferralCode: (code: string) =>
    axiosInstancePromotion.post<void>(
      `${AFFILIATE_DOMAIN}/${AFFILIATE_REFERRAL_SAVE_ENDPOINT}`,
      {
        code: code,
      }
    ),

  // 비인증(로그인 전) 게이트 유효성 검사 — 유효 여부 + 표시용 제휴사 이름 반환
  validate: (code: string) =>
    axiosInstancePromotion.get<CustomResponseFormat<AffiliateReferralInfo>>(
      `${AFFILIATE_DOMAIN}/${AFFILIATE_REFERRAL_VALIDATE_ENDPOINT}`,
      { params: { code } }
    ),
};
